import { useEffect, useState } from "react";
import QuestionBox from "../../ui/QuestionBox/QuestionBox";
import RadioButton from "../../ui/RadioButton/RadioButton";
import classes from "../Infrastructure/Infrastructure.module.css";
import QuestionCard from "../../ui/QuestionCard/QuestionCard";
import CommonFooter from "../../CommonFooter/CommonFooter";
import axios from "axios";
import { useAuth } from "../../../context/AuthContext";
import { env } from "../../../constants/env";
import { Bounce, toast } from "react-toastify";
import InputField from "../../ui/InputField/InputField";
import { useParams } from "react-router-dom";
import CommonButton from "../../ui/CommonButton/CommonButton";
import { useQuestionnaire } from "../../../hooks/useQuestionnaire";

const initialState = {
  receivesReferralSpecimens: "",
  testsReferredToOtherLabs: ["", ""],
  referralDistanceKm: "",
  referralTurnAroundTime: [
    {
      serial: "",
      testName: "",
      tat: "",
    },
  ],

  referralComment: "",
};

const SpecimenReferral = () => {
   const {
      formData,
      setFormData,
      handleChange,
      handleDone,
      editMode,
      setEditMode,
      isReadOnly,
      isFetching,
      loading,
      isOffline,
    } = useQuestionnaire("specimen-referral", initialState);

  const [currentSet, setCurrentSet] = useState(0);

  const { user } = useAuth();

  const { labId: paramLabId } = useParams();

  const userRole = user?.role;


  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet(currentSet + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet(currentSet - 1);
  };


  const questionSets = [
    {
      subtitle: "Specimen referral to other laboratories",
      content: (
        <div className="d-flex flex-column gap-4">
          <QuestionBox
            number={1}
            question="Does the laboratory receive referral specimens from other laboratories"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-4">
              <RadioButton
                label="Yes"
                name="receivesCommunication"
                checked={formData.receivesCommunication === "Yes"}
                onChange={() => handleChange("receivesCommunication", "Yes")}
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                name="receivesCommunication"
                checked={formData.receivesCommunication === "No"}
                onChange={() => handleChange("receivesCommunication", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>
          <QuestionBox
            number={2}
            question="List the tests referred to other Laboratories"
            singleInput
            answers={formData.testsReferredToOtherLabs}
            onAnswersChange={(newAnswers) =>
              handleChange("testsReferredToOtherLabs", newAnswers)
            }
            disabled={isReadOnly}
          />

          <QuestionBox
            number={3}
            question="Approximation of the distance to the referral Laboratory (In Kilometers)"
            disabled={isReadOnly}
          >
            <div
              className={`${classes.customInput} d-flex align-items-center gap-2`}
            >
              <div className={classes.prepend}>KM</div>
              <input
                type="text"
                placeholder="Enter distance"
                onChange={(e) =>
                  handleChange("referralDistanceKm", e.target.value)
                }
                value={formData.referralDistanceKm}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={4}
            question="Turn Around Time(TAT) for the referred tests"
            groupedInput
            answers={formData.referralTurnAroundTime}
            onAnswersChange={(updated) =>
              // setFormData((prev) => ({
              //   ...prev,
              //   referralTurnAroundTime: updated,
              // }))
              handleChange("referralTurnAroundTime", updated)
            }
            multilineInput
            placeholder="Add comment"
            value={formData.referralComment}
            onChange={(e) => handleChange("referralComment", e.target.value)}
            disabled={isReadOnly}
          ></QuestionBox>
        </div>
      ),
    },
  ];

  const { subtitle, content } = questionSets[currentSet];

  if (isFetching) {
    return <div className={classes.loading}>Loading...</div>;
  }

  return (
     <div
      className={`${classes.wrapper} ${
        paramLabId ? classes.fromParams : ""
      } ${isReadOnly ? classes.readOnly : ""}`}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h2>Specimen referral</h2>
        {userRole === "LABORATORY" && !editMode && (
          <CommonButton
            className={classes.editButton}
            onClick={() => setEditMode(true)}
            title="Edit"
          />
        )}
      </div>
      {(!editMode && userRole !== "MINISTRY") ? (
        <div className={classes.infoText}>
          ✅ Your specimen referral has been submitted.
        </div>
      ) : (
        content
      )}
      {!isReadOnly && (
        <CommonFooter
          handlePrevious={handlePrevious}
          handleNext={handleNext}
          handleDone={handleDone}
          cancelText="Cancel"
          handleCancel={() => {
            setEditMode(false);
            setCurrentSet(0);
          }}
          questionSets={questionSets}
          currentSet={currentSet}
          doneText={
            loading ? "Submitting..." : isOffline ? "Save Offline" : "Submit"
          }
          disabled={loading}
        />
      )}
    </div>
  );
};

export default SpecimenReferral;
